export default "__VITE_ASSET__DlavR32j__"